(function ($) {
  $(".bullet-section-wrap").each(function () {
    $(this).find("img").hide();
    var _Bg = "url(" + $(this).find("img").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img").hide();
  });

  $(".p-img > a").each(function () {
    $(this).find("img").hide();
    var _Bg = "url(" + $(this).find("img").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img").hide();
  });

  setTimeout(function () {
    $('[title="mailto:jennjackson@zugucase.com"]').attr(
      "aria-label",
      "Contact us through email jennjackson@zugucase.com"
    );
  }, 2000);
  //   $('.bullet').click(function(){
  //     $(this).parent().toggleClass('bullet--active');
  //   })

  $(document).ready(function () {
    $(
      ".bullet-section-wrap .everything-you-need__StyledBullet-sc-12tayus-1>.bullet"
    ).click(function () {
      $(
        ".bullet-section-wrap .everything-you-need__StyledBullet-sc-12tayus-1>.bullet"
      )
        .parent()
        .removeClass("bullet--active");
      $(this).parent().addClass("bullet--active");
    });
  });
  $(".bullet__close").click(function () {
    $(this).parents().removeClass("bullet--active");
  });

  setInterval(function () {}, 1000);

  $(".toogle_text").click(function () {
    $(this).next(".text-show").toggle(500);
  });
  $("body").on("click", ".menu-link-cart", function (event) {
    $(this).toggleClass("active");
    $("body").toggleClass("hid");
    $(".side-cart").toggleClass("active");
    $(".overla").toggleClass("cv-cart-open-overlay");
  });

  $(".header__nav-button").click(function () {
    $(this).toggleClass("active");
    $(".mobile-menu").toggleClass("active");
  });

  $(".shop-list h4").click(function () {
    $(this).toggleClass("show");
    $(this).next("ul").toggleClass("show");
  });

  $(".r-more").click(function () {
    $(this).hide();
    $(".r-content").addClass("show");
  });

  $(".r-less").click(function () {
    $(".r-more").show();
    $(".r-content").removeClass("show");
  });

  $(".product-slider").slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    slidesToScroll: 1,
  });

  $(".product-slider-dots").slick({
    vertical: true,
    arrows: true,
    infinite: true,
    slidesToShow: 0,
    slidesToScroll: 1,
    asNavFor: ".product-slider",
    dots: false,
    focusOnSelect: true,
    verticalSwiping: false,
    centerMode: false,
    speed: 0,
    responsive: [
      {
        breakpoint: 580,
        settings: {
          infinite: false,
          focusOnSelect: false,
          slidesToShow: 6,
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  });
  setTimeout(function () {
    jQuery("div#thumbnail-gallery").addClass("hidden_arrow");
  }, 2000);

  let currentTranslate = 0;
  const minTranslate = -240;
  const maxTranslate = 0;
  const slickTrackLength = $(".product-slider-dots .slick-track .item").length;
  if (slickTrackLength > 6) {
    $(".arrow-slider").show();
  } else {
    $(".arrow-slider").hide();
  }

  function updateTranslate(increment) {
    currentTranslate += increment;
    currentTranslate = parseInt(currentTranslate);

    // Ensure the currentTranslate stays within the specified range
    currentTranslate = Math.max(
      minTranslate,
      Math.min(maxTranslate, currentTranslate)
    );

    console.log(currentTranslate);
    $(".product-slider-dots .slick-track").css("left", currentTranslate);

    // Check the length of .slick-track and show/hide .arrow-slider accordingly
    setInterval(function () {
      const slickTrackLength = $(
        ".product-slider-dots .slick-track .item"
      ).length;
      if (currentTranslate == 0) {
        $(".arrow-slider-bottom").hide();
      } else {
        $(".arrow-slider-bottom").show();
      }
      if (currentTranslate == -240) {
        $(".arrow-slider-top").hide();
      } else {
        $(".arrow-slider-top").show();
      }
      if (slickTrackLength > 6) {
        $(".arrow-slider").show();
      } else {
        $(".arrow-slider").hide();
      }
    }, 1000);
  }

  window.updateTranslate = updateTranslate;

  (function () {
    const selectors = {
      mainSelect: "#productSelect",
    };
    const mainSelector = document.querySelector(selectors.mainSelect);

    if (!mainSelector) return;

    const handleVariantChange = () => {
      console.log("variant-updated");
      console.log(mainSelector.selectedOptions[0].value);

      fetch(`${window.location.href}&section_id=main-product-12point9`)
        .then((res) => res.text())
        .then((data) => {
          const sectionHTML = new DOMParser().parseFromString(
            data,
            "text/html"
          );

          const sourceSlider = sectionHTML.querySelector(".product-slider");
          const destinationSlider = document.querySelector(".product-slider");

          const sourceThumbSlider = sectionHTML.querySelector(
            ".product-slider-dots-slider"
          );
          const destinationThumbSlider = document.querySelector(
            ".product-slider-dots-slider"
          );

          if (sourceThumbSlider && destinationThumbSlider) {
            destinationThumbSlider.outerHTML = sourceThumbSlider.outerHTML;
          }

          $(".product-slider-dots").slick({
            vertical: true,
            arrows: false,
            infinite: true,
            slidesToShow: 0,
            slidesToScroll: 1,
            asNavFor: ".product-slider",
            dots: false,
            focusOnSelect: true,
            centerMode: false,
            speed: 0,
            verticalSwiping: false,
            responsive: [
              {
                breakpoint: 580,
                settings: {
                  infinite: false,
                  focusOnSelect: false,
                  slidesToShow: 6,
                  vertical: false,
                  verticalSwiping: false,
                },
              },
            ],
          });
          jQuery("div#thumbnail-gallery").addClass("hidden_arrow");
        });
    };

    document.addEventListener("variant:change", () => {
      setTimeout(handleVariantChange, 100);
    });
  })();

  $(".swatch-element label").click(function () {
    currentTranslate = 0;
    $(".product-slider-dots-slider").addClass("temp_class");
    document.dispatchEvent(new CustomEvent("variant:change"));
  });

  $(".swatch-element label").keydown(function (event) {
    if (event.key === "Enter") {
      currentTranslate = 0;
      $(".product-slider-dots-slider").addClass("temp_class");
      document.dispatchEvent(new CustomEvent("variant:change"));
    }
  });

  $(".everything-carousel").slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,

    slidesToScroll: 1,
  });

  $(".news-carousel").slick({
    dots: true,
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".reviews_carousel").slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".z-testimonial-slide").slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".related-products-carousel").slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: true,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".collection-slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
  });

  var btn = $(".back-to-top");

  $(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
      btn.addClass("show");
    } else {
      btn.removeClass("show");
    }
  });

  btn.on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "300");
  });

  function checkOffset() {
    if (
      $(".back-to-top").offset().top + $(".back-to-top").height() >=
      $("#footer_bottom_row").offset().top - 10
    )
      $(".back-to-top").addClass("btt");
    if (
      $(document).scrollTop() + window.innerHeight <
      $("#footer_bottom_row").offset().top
    )
      $(".back-to-top").removeClass("btt"); // restore when you scroll up
    // $('#ch').text($(document).scrollTop() + window.innerHeight);
  }
  $(document).scroll(function () {
    checkOffset();
  });

  // $("ul.accordion").accordion();

  var mode = $(window).innerWidth() >= 1024 ? "PC" : "MOBILE";

  if (mode == "PC") {
  } else if (mode == "MOBILE") {
    $(".m-menu").attr("href", "javascript:;");
  }

  $(document).ready(function () {
    //   $('.down').on('click', function(e) {
    // 				e.preventDefault(); // prevent hard jump, the default behavior
    // 				var target = $(this).attr("href"); // Set the target as variable
    // 				console.log(target);
    // 				$('html, body').stop().animate({
    // 						scrollTop: $(target).offset().top - 80
    // 				}, 600, function() {
    // 						//location.hash = target; //attach the hash (#jumptarget) to the pageurl
    // 						console.log($(target).offset().top);
    // 				});
    // 				return false;
    // 		});
  });

  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - 120,
            },
            600,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });
  jQuery(".side-cart-inner").mCustomScrollbar({
    scrollButtons: { enable: true },
    theme: "dark",
    scrollbarPosition: "outside",
    updateOnContentResize: true,
  });

  $(".overla").click(function () {
    $(".side-cart").removeClass("active");
    $(".overla").removeClass("cv-cart-open-overlay");
  });

  // cart for app chckout buddy
  setInterval(function () {
    $(".cart-item").each(function () {
      // Get data-package-id attribute value as an integer
      var packageId = $(this).attr("data-package-id");
      var itemId = $(this).attr("data-item-id");
      // console.log('packageId', packageId);
      // console.log('itemId', itemId);

      let check_integer = parseInt(packageId);

      // Check if data-package-id is an integer
      if (isNaN(check_integer)) {
        $(this).attr("data-package-id", itemId);
        $(this).find("a.remove-cart").attr("data-time", itemId);
      } else {
      }
    });
  }, 1000);
})(jQuery);

$(function () {
  $(".innerLanguages").on("click", function () {
    $(".innerLanguages").toggleClass("devActive");
    $(".devLanguagesDropdown").toggle();
  });
});

$(".diblmn").click(function (event) {
  event.preventDefault();
  $(".search-results").show();
  $(".search-results li").focus();
});

$(".foo").each(function () {
  var _bg = $(this).find("img").attr("src");
  $(this).css("background-image", "url(" + _bg + ")");
});

$(document).ready(function () {
  if (window.location.href.indexOf("viewcart") > -1) {
    $(".side-cart").addClass("active");
  }

  $('[role="link"]').on("keydown", function (event) {
    if (event.key === "Enter") {
      $(this).click(); // Simulate a click on the element
    }
  });
});

$(document).ready(function () {
  if (window.location.href.indexOf("limited-fb-promo") > -1) {
    // Store
    localStorage.setItem("limited-fb-promo", "YES");
    // Retrieve
    console.log(localStorage.getItem("limited-fb-promo"));
  }
  console.log(localStorage.getItem("limited-fb-promo"));
  if (localStorage.getItem("limited-fb-promo") == "YES") {
  }
});

// jQuery('.video').parent().click(function () {
// 	if ($(this).children(".video").get(0).paused) {
// 		$(this).children(".video").get(0).play(); $(this).children(".playpause").fadeOut();

// 	} else {
// 		$(this).children(".video").get(0).pause();
// 		$(this).children(".playpause").fadeIn();
// 	}
// });

jQuery(".playpause, .cadjbcvao, .video").click(function () {
  if ($(this).parents().find(".video").get(0).paused) {
    $(this).parents().find(".video").get(0).play();
    $(this).addClass("pause");
  } else {
    $(this).parents().find(".video").get(0).pause();
    $(this).removeClass("pause");
  }
});

jQuery(document).ready(function ($) {
  var video = $(".video")[0];
  setTimeout(function () {
    video.controls = false;
  }, 0);
});

// tab focus on cart active and not activve
jQuery(document).ready(function ($) {
  $(".side-cart .window__closer").click(function () {
    $(".menu-link-cart.active").is(":focus");
  });
  $(".menu-link-cart.active").click(function () {
    $(".menu-link-cart.active").is(":focus");
  });
  $(document).on("keydown", function (e) {
    // Check if Tab key (keyCode 9) is pressed
    if (e.key === "Tab" || e.keyCode === 9) {
      // Check if the currently focused element is '.side-cart.active .continue-shopping'
      if (
        $(".side-cart.active .continue-shopping").is(":focus") ||
        $(".side-cart.active .govx-id-slim a").is(":focus") ||
        $("a.menu-link.menu-link-cart.active").is(":focus")
      ) {
        // Prevent default tabbing behavior (optional, if needed)
        e.preventDefault();

        // Move focus to the '.window__closer' button
        $(".side-cart .window__closer").focus();
      }

      if ($(".bthma a").is(":focus")) {
        // Prevent default tabbing behavior (optional, if needed)
        e.preventDefault();

        // Move focus to the '.window__closer' button
        $(".shop-menu .window__closer").focus();
      }
    }
  });
});

$(".show-t").click(function () {
  $(".hide-con").toggleClass("show");
});
$(document).ready(function () {
  // Selectors for elements
  var $modal = $(".mobile-menu");
  var $modalTrigger = $(".header__nav-button");
  var focusableElementsString =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var $focusableElements;
  var $firstFocusableElement;
  var $lastFocusableElement;

  // Function to open modal
  function openModal() {
    $focusableElements = $modal
      .find(focusableElementsString)
      .filter(":visible");
    $firstFocusableElement = $focusableElements.first();
    $lastFocusableElement = $focusableElements.last();
    $firstFocusableElement.focus();

    $(document).on("keydown", trapFocus);
  }

  // Function to close modal
  function closeModal() {
    $(document).off("keydown", trapFocus);
    $modalTrigger.focus(); // Return focus to the trigger button
  }

  // Function to trap focus within the modal
  function trapFocus(e) {
    if (e.key === "Tab" || e.keyCode === 9) {
      if (e.shiftKey) {
        // If Shift + Tab
        if ($(document.activeElement).is($firstFocusableElement)) {
          e.preventDefault();
          $modalTrigger.focus(); // Shift focus to the trigger button
        }
      } else {
        // If Tab
        if ($(document.activeElement).is($lastFocusableElement)) {
          e.preventDefault();
          $modalTrigger.focus(); // Shift focus to the trigger button
        }
      }
    } else if (e.key === "Escape" || e.keyCode === 27) {
      closeModal();
    }
  }

  // Trigger to open modal
  $modalTrigger.on("click", openModal);

  // Optionally, close the modal if clicked outside the content
  $modal.on("click", function (e) {
    if ($(e.target).is($modal)) {
      closeModal();
    }
  });

  // You can also bind a close button if you have one
  $(".close-modal-button").on("click", closeModal);
});

$(document).ready(function () {
  // Add an offscreen live region for accessibility announcements
  // $("body").append(
  //   ''
  // );

  $(".accessibility-link a").focus();

  $(".accordion_content").slideUp();
  $(".accordion > li > a").click(function () {
    var $content = $(this).next(".accordion_content");
    var $trigger = $(this);

    // Slide up all accordion_content elements except the clicked one
    $(".accordion_content")
      .not($content)
      .slideUp()
      .parent("li")
      .removeClass("active")
      .prev("a")
      .attr("aria-expanded", "false")
      .attr("toggle", "false");

    // Slide toggle the clicked accordion_content, toggle 'active' class, and update attributes
    $content.slideToggle(function () {
      if ($content.is(":visible")) {
        $trigger.attr("aria-expanded", "true").attr("toggle", "true");
        $trigger.parent("li").addClass("active");

        // Announce the state change via live region
        $("#live-region").text($trigger.find("span").text() + " expanded");
      } else {
        $trigger.attr("aria-expanded", "false").attr("toggle", "false");
        $trigger.parent("li").removeClass("active");

        // Announce the state change via live region
        $("#live-region").text($trigger.find("span").text() + " collapsed");
      }
    });
  });

  // Second level sccordion
  $(".sub_q").click(function () {
    var $answer = $(this).next(".sub_a");
    var $question = $(this);

    // Slide up all .sub_a elements except the clicked one, remove 'active' class, and update attributes
    $(".sub_a")
      .not($answer)
      .slideUp()
      .removeClass("active")
      .prev(".sub_q")
      .attr("aria-expanded", "false")
      .attr("toggle", "false");

    // Slide toggle the clicked .sub_a, toggle 'active' class, and update attributes
    $answer.slideToggle(function () {
      if ($answer.is(":visible")) {
        $answer.addClass("active");
        $question.attr("aria-expanded", "true").attr("toggle", "true");

        // Update the live region to announce the state change
        $("#live-region").text($question.text() + " expanded");
      } else {
        $answer.removeClass("active");
        $question.attr("aria-expanded", "false").attr("toggle", "false");

        // Update the live region to announce the state change
        $("#live-region").text($question.text() + " collapsed");
      }
    });
  });

  $(".menu-link-shop").click(function () {
    var $this = $(this); // Store reference to the clicked element

    // Toggle 'active' class on the clicked menu link and shop menu wrapper
    $this.toggleClass("active");
    $(".shop-menu-wrap").toggleClass("active");

    // Check if the shop menu wrapper has the 'active' class
    if ($(".shop-menu-wrap").hasClass("active")) {
      // Update aria-expanded and toggle attributes when expanded
      $this.attr("toggle", "true").attr("aria-expanded", "true");
      $(".shop-menu-wrap").attr("toggle", "true").attr("aria-expanded", "true");

      // Announce the state change to screen readers
      $("#live-region").text($this.text() + " expanded");
    } else {
      // Update aria-expanded and toggle attributes when collapsed
      $this.attr("toggle", "false").attr("aria-expanded", "false");
      $(".shop-menu-wrap")
        .attr("toggle", "false")
        .attr("aria-expanded", "false");

      // Announce the state change to screen readers
      $("#live-region").text($this.text() + " collapsed");
    }
  });

  // shop close button
  $(".shop-menu .window__closer").click(function () {
    // Remove 'active' class from menu link and shop menu wrapper
    $(".menu-link-shop")
      .removeClass("active")
      .attr("aria-expanded", "false")
      .attr("toggle", "false");
    $(".shop-menu-wrap")
      .removeClass("active")
      .attr("aria-expanded", "false")
      .attr("toggle", "false");
    $(".menu-link-shop").focus();
    // Announce the closing state via live region
    $("#live-region").text("Shop menu closed");
  });

  // shop mobile menu
  $(".shop-list h4.mob").click(function () {
    var $this = $(this);
    var $productList = $this.next(".collection__products");

    // Toggle the visibility of the product list
    // $productList.slideToggle(300);

    // Check if the product list is visible or not
    if ($productList.is(":visible")) {
      $this.attr("aria-expanded", "true").attr("toggle", "true");
      $productList.attr("aria-expanded", "true").attr("toggle", "true");
      $("#live-region").text($this.text() + " expanded.");
    } else {
      $this.attr("aria-expanded", "false").attr("toggle", "false");
      $productList.attr("aria-expanded", "false").attr("toggle", "false");
      $("#live-region").text($this.text() + " collapsed.");
    }
  });

  // Cart show button
  $("a.menu-link.menu-link-cart").click(function () {
    $(".side-cart .window__closer").focus();
    // Announce the closing state via live region
    $("#live-region").text("Cart Expanded");
  });

  $("a.btn.add_to_cart_button, button#AddToCart").click(function () {
    var interval = setInterval(function () {
      // Attempt to set focus to the ".side-cart .window__closer"
      $(".side-cart .window__closer").focus();

      // Check if the focus is successfully set
      if ($(".side-cart .window__closer").is(":focus")) {
        $("#live-region").text("Cart Expanded");
        clearInterval(interval); // Exit the interval once focus is set
      }
    }, 100); // Check every 100 milliseconds
  });

  // Cart close button
  $(".side-cart .window__closer, .side-cart-overlay").click(function () {
    // Remove 'active' class from side cart and body classes
    $(".side-cart").removeClass("active");
    $("body").removeClass("hid");

    // Remove 'active' class from cart menu link
    $(".menu-link-cart")
      .removeClass("active")
      .attr("aria-expanded", "false")
      .attr("toggle", "false");

    // Remove overlay active class
    $(".overla").removeClass("cv-cart-open-overlay");

    setTimeout(function () {
      $(".menu-link-cart").focus();
      // Announce the closing state via live region
      $("#live-region").text("Cart closed");
    }, 500);
  });

  // click here toggle button
  $(".toogle_text").attr("aria-expanded", "false").attr("toggle", "false");
  $(".toogle_text").click(function () {
    // Toggle visibility of the next element with class .text-show
    $(this).toggleClass("active").next(".text-show").toggle(500);

    $(".toogle_text").attr("aria-expanded", "false").attr("toggle", "false");
    $(".toogle_text.active")
      .attr("aria-expanded", "true")
      .attr("toggle", "true");

    if ($(".toogle_text").hasClass("active")) {
      $("#live-region").text("Click here button Expanded.");
    } else {
      $("#live-region").text("Click here button collapsed.");
    }
  });
});

